import { MainLoadingSkeleton } from 'components/Directories/Styled'
import {
  PostProfileCTAContainer,
  PostProfileCTAText,
  CTAButtonContainer,
  CTAButton,
} from './Styled'

const PostProfileCTA = ({
  postProfileCtaText,
  postProfileCtaButtonLink,
  postProfileCtaButtonText,
  hasListing,
  isLoading,
}) => {
  if (hasListing === false) {
    if (isLoading === false) {
      return (
        <PostProfileCTAContainer>
          <PostProfileCTAText
            display={{ _: 'block', desktop: 'inline-block' }}
            padding='1rem'
            fontSize='20px'
            m='0px'
            verticalAlign='middle'
            width={{ _: 'auto', desktop: '65%' }}
          >
            {postProfileCtaText}
          </PostProfileCTAText>
          <CTAButtonContainer
            display={{ _: 'block', desktop: 'inline-block' }}
            margin={{ _: 'auto', desktop: 0 }}
            width={{ _: '14rem', desktop: '16rem' }}
          >
            <CTAButton
              href={postProfileCtaButtonLink}
              display='block'
              fontSize='16px'
              padding='1rem'
              maxWidth='16rem'
              mb='0px'
            >
              {postProfileCtaButtonText}
            </CTAButton>
          </CTAButtonContainer>
        </PostProfileCTAContainer>
      )
    } else {
      return (
        <MainLoadingSkeleton
          minWidth={{ _: '335px', tablet: '360px', desktop: '945px' }}
          minHeight={{ _: '144px', desktop: '96px' }}
        />
      )
    }
  }
  return null
}

export default PostProfileCTA
